import { createAction } from 'typesafe-actions';
import { NotificationDto } from '../dtos/notification.dtos';

export const notification = createAction('SHOW_NOTIFICATION')<NotificationDto>();
